// https://www.npmjs.com/package/react-native-vector-icons
/*
 * react-icons-kit (https://www.npmjs.com/package/react-icons-kit)
 * provides 11 icon sets
 * unfortunatelly ionic iconset is quite old
 */
import * as _Entypo from "react-icons-kit/entypo/";
import * as _FontAwesome from "react-icons-kit/fa/";
import * as _Iconic from "react-icons-kit/iconic/"; // open iconic
import * as _IcoMoon from "react-icons-kit/icomoon/";
import * as _Ikons from "react-icons-kit/ikons/";
import * as _Ionicons2 from "react-icons-kit/ionicons/"; // ionicons v2
import * as _Linea from "react-icons-kit/linea/";
import * as _Material from "react-icons-kit/md/";
import * as _Metrize from "react-icons-kit/metrize/";
import * as _Octicons from "react-icons-kit/oct/";
import * as _Typicons from "react-icons-kit/typicons/";
/*
 * Ionic v3 has a separate import
 */
//import Ionicon from "react-ionicons";
import _Ionicons3 from "react-ionicons/src/icons"; // ionicons v3

export const _AvailableIconsets = {
	entypo: () => _Entypo,
	fontawesome: () => _FontAwesome,
	icomoon: () => _IcoMoon,
	iconic: () => _Iconic,
	ionicons2: () => _Ionicons2,
	ionicons3: () => {
		return _Ionicons3.map(item => {
			return item.tags[0]; // return the first (and only) element of tags key
		});
	},
	ikons: () => _Ikons,
	linea: () => _Linea,
	metrize: () => _Metrize,
	octicons: () => _Octicons,
	typicons: () => _Typicons,
	material: () => _Material
};

export const _DefaultIconset = "material";

export const _DefaultIconSize = 60;

export const _DefaultIconColor = "#4F4F4F";

/*
 * Functions
 */

// try to guess the iconset, use the "_DefaultIconset" value otherwise...
export function guessIconset(iconset) {
	if (_AvailableIconsets[iconset]) {
		return iconset;
	}
	let retval;
	switch (iconset) {
		case "fa":
			retval = "fontawesome";
			break;
		case "ionicons":
			retval = "ionicons3";
			break;
		case "oct":
			retval = "octicons";
			break;
		default:
			retval = _DefaultIconset;
	}
	return retval;
}

// get all icon
export function getAllIcons(iconset) {
	iconset = guessIconset(iconset);
	return _AvailableIconsets[iconset]();
}

// return true if is ionicons
export function isIonicons(iconset) {
	if (!iconset) {
		console.log("Error: isIonicons (Iconset.js) null parameter");
	}
	return iconset === "ionicons3" ? true : false;
}

// get svg data
export function getReactIconsKitSvg(iconset, icon) {
	if (isIonicons(iconset)) {
		return null;
	}
	// get svg icon data
	let data = _AvailableIconsets[iconset]();
	return data[icon];
}



// WEBPACK FOOTER //
// ./src/components/IconPicker/Iconset.js